export default "__VITE_ASSET__x$G8Dm5L__"